
// 跳转声音商店
/**
 * @param param {speaker, speakerName} 
 */
export const toVoiceShop = (param) => {
  let openVoiceShopPage: any = (window as any).openVoiceShopPage
  if (openVoiceShopPage) {
    param = JSON.stringify(param)
    openVoiceShopPage.postMessage(param)
  }
}
export const toBeVip = () => {
  let openVipPage: any = (window as any).openVipPage
  if (openVipPage) {
    openVipPage.postMessage("")
  }
}